import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actions from '../../actions/CommentActions'

class ModalReply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            reply: '',
            nameUser: ''
        }
    }

    componentDidMount() {
        if (this.props.comment) {
            this.setState({
                comment: this.props.comment.comment,
                reply: this.props.comment.reply,
                nameUser: this.props.comment.nameUser
            })
        }
    }

    closeModal = () => {
        this.props.hideModal();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleClearFrom = () => {
        this.setState({
            reply: ''
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        var { reply } = this.state;
        var { comment } = this.props;
        console.log(comment);
        if (reply === "") {
            alert("Mời nhập bình luận")
        } else {
            this.props.replyComment({
                comment: comment.comment,
                date: comment.date,
                idProduct: comment.idProduct,
                nameUser: comment.nameUser,
                reply: reply,
                id: comment.id
            });
            alert("Bình luận thành công !")
            this.handleClearFrom();
            this.closeModal();
        }
    }

    render() {
        var { comment } = this.props;
        var { reply } = this.state
        if (comment) {
            return (
                <>
                    <Modal.Header>
                        <Modal.Title>
                            Reply Comment
                        </Modal.Title>
                        <button
                            type="button"
                            className="close-header"
                            onClick={this.closeModal}
                        >
                            <i className="fa fa-times mr-3"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form">
                            <input name="form_type" type="hidden" defaultValue="contact" />
                            <div className="form-group">
                                <label htmlFor="contactFormAuthor" className="sr-only">
                                    Nội dung
                                </label>
                                <input
                                    required
                                    type="text"
                                    id="contactFormAuthor"
                                    className="form-control input-lg"
                                    name="reply"
                                    placeholder="Reply"
                                    autoCapitalize="words"
                                    value={reply}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <button
                                className="btn btn-primary btn-lg btn-rb mr-3"
                                onClick={this.handleSubmit}
                            >
                                Reply
                            </button>
                            <button
                                className="btn btn-outline-secondary btn-lg"
                                onClick={this.closeModal}
                            >Huỷ</button>
                        </div>
                    </Modal.Body>
                </>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.modal
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        replyComment: comment => {
            dispatch(actions.fetchAPIReplyComment(comment))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalReply);
